import type { TourConfig } from '../../types/tour.types'

// Uses stable, existing selectors (layout + dashboard classes) so no view edits
// are needed. Teaches context first, controls last (adult-learning order).
const dashboardTour: TourConfig = {
  id: 'dashboard',
  title: 'Welcome to TAMI',
  module: 'Getting Started',
  routeName: 'Dashboard',
  order: 1,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: "Let's turn TAMI into pipeline",
      body: 'TAMI helps you **find the right companies and people, reach them, and keep your CRM clean** — all in one place. This 60-second tour shows how it makes you money, not just where the buttons are.',
    },
    {
      id: 'sidebar',
      target: '.app-sidebar',
      placement: 'end',
      title: 'Your workspace, one click away',
      body: 'Everything lives here: build lists, search people, enrich data, and connect your CRM. Think of it as the path from **a blank page to booked meetings**.',
    },
    {
      id: 'search',
      target: '.app-topbar__search',
      placement: 'bottom',
      title: 'Find any company in seconds',
      body: 'Type a company name, website, or even a plain-English description of your ideal customer. This is the fastest way to **start a targeted list** instead of guessing.',
    },
    {
      id: 'stats',
      target: '.dashboard__stats',
      placement: 'top',
      title: 'Know your firepower',
      body: 'Your export and mobile credits at a glance — so you always know how much prospecting you can do before you spend a minute on it.',
    },
    {
      id: 'cta',
      target: '.dashboard__cta',
      placement: 'start',
      title: 'Run your first search',
      body: 'Ready? Kick off a search and start building your first list. You can always come back here to pick up where you left off.',
      aiAction: {
        prompt: 'Help me build my first targeted company list. Ask me about my ideal customer and create the list.',
        label: 'Let the AI build my first list',
      },
    },
    {
      id: 'help',
      target: '[data-tour="help-button"]',
      placement: 'bottom',
      title: 'Help is always one click away',
      body: 'Stuck on any screen? Open this menu for a guided tour or the screen guide — or just **ask the AI to do it for you**. You never have to learn everything at once.',
    },
  ],
}

export default dashboardTour
